import {Input} from "@varymadellc/my-weed-club-component-library";
import {useEffect, useState} from "react";
import {DiaryEntryType} from "@/types";
import {useSiteMessage} from "@/providers/SiteMessageProvider";
import {apiGet, extractPayloadFromResponse} from "@/services/apiService";
import DiaryEntryLog from "@/components/DiaryEntryLog/DiaryEntryLog";
import Page from "@/layout/Page";
import isValidToken from "@/utils/auth";
import {useAuth} from "@/providers/AuthProvider";
import DiaryPublicNav from "@/layout/nav/DiaryPublicNav";

const sortByType = (type) => (a: DiaryEntryType, b: DiaryEntryType) => {
    if (a[type] < b[type]) return 1;

    if (a[type] > b[type]) return -1;

    return 0;
};

const sortByValue = (a: DiaryEntryType, b: DiaryEntryType) => {
    let score = 0;

    if (!a.thoughts?.length && b.thoughts?.length) {
        score++;
    }

    if (a?.thoughts?.length > b?.thoughts?.length) {
        score--;
        score--;
    }

    if (a?.thoughts?.length < b?.thoughts?.length) {
        score++;
    }

    if (a?.entryDate > b?.entryDate) {
        score--;
    } else if (a?.entryDate < b?.entryDate) {
        score++;
    }

    return score;
}

const getStrainByHighest = (diaryEntries: DiaryEntryType[], type: 'feel' | 'taste' | 'smell' | 'look') => {
    let highestStrainByType = diaryEntries.sort(sortByValue);

    const highestStrain = highestStrainByType.sort(sortByType(type))[0];

    if (!highestStrain) {
        return false;
    }

    return highestStrain.strain;
}

export default function DiaryLogPage() {
    const {authToken} = useAuth();

    const {setMessage} = useSiteMessage();

    const [search, setSearch] = useState<string>('');

    const [entries, setEntries] = useState<any[]>([]);

    useEffect(() => {
        async function getData() {
            try {
                const response = await apiGet('/public/diary');

                const {diaryEntries} = await extractPayloadFromResponse(response);

                setEntries(diaryEntries);
            } catch (error: any) {
                setMessage(error.message);
            }
        }

        getData();
    }, [setMessage]);

    const getTopMentionedBrands = () => {
        const brandsCount = entries.reduce((acc, entry) => {
            acc[entry.brand] = acc[entry.brand] ? acc[entry.brand] + 1 : 1;
            return acc;
        }, {});

        const brandsCountSorted = Object.keys(brandsCount).sort((brandA, brandB) => brandsCount[brandB] - brandsCount[brandA]);

        return brandsCountSorted.reduce((acc, brand) => {
            return acc + ' ' + brand + ': ' + brandsCount[brand] + ",";
        }, '');
    };

    const topMentionedBrands = getTopMentionedBrands();

    return (
        <Page title="Diary - Public Log" menu={<DiaryPublicNav/>}>
            <p>Welcome to the public side of the site. We offer to you the public, our internal diary posts about
                cannabis use.</p>
            <p>The intention is that we provide you with some useful insight into how the products that you consume,
                affect others.</p>
            <p>Or for the producers/vendors out there, you can see how your products are being consumed and how others
                feel about it.</p>
            <div className="bg-secondary p-2 rounded text-black my-2">
                <h2 className="text-xl">Stats</h2>
                <hr className="m-2"/>
                <p><span className="font-bold">Number of entries:</span> {entries.length}</p>
                <p><span className="font-bold">Top Mentioned Brand:</span> {topMentionedBrands}</p>
            </div>
            <div className="mx-auto w-8/12 text-center p-2">
                <label htmlFor="search">
                    Search
                </label>
                <Input name="search" className="w-full" onChange={({target: {value}}: any) => setSearch(value)}/>
            </div>
            <DiaryEntryLog hideHashTags={!isValidToken(authToken)} diaryEntries={entries} search={search}/>
        </Page>
    );
}